import React from "react";

/* =====================================================================
   Unavailable panel
   =====================================================================
   Shown when a whole section cannot load -- currently the casino, whose
   catalogue comes from an external provider and so can fail entirely
   independently of the sportsbook.

   Three things a failure state has to do, which a bare "Something went
   wrong" does not:
     - say what is missing, in the reader's terms, not the server's
     - say what still works, so the page does not read as fully broken
     - give a way forward: retry, and somewhere else worth going

   The artwork is a muted, drawn placeholder rather than a red error
   icon: nothing here is the visitor's fault and nothing is on fire.
   ===================================================================== */

const UnavailablePanel = ({
  title = "This section is unavailable right now",
  body,
  onRetry,
  retrying,
  secondaryLabel,
  onSecondary,
  note,
}) => (
  <div className="rb-unavailable" role="status">
    <div className="rb-unavailable__art" aria-hidden="true">
      {/* A dealt-out card fan with one card missing -- reads as "the
          set is incomplete" rather than "error". */}
      <svg viewBox="0 0 120 80" width="120" height="80" focusable="false">
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        >
          <rect x="10" y="26" width="30" height="42" rx="4" transform="rotate(-12 25 47)" />
          <rect x="45" y="22" width="30" height="42" rx="4" />
          <rect
            x="80"
            y="26"
            width="30"
            height="42"
            rx="4"
            transform="rotate(12 95 47)"
            strokeDasharray="4 4"
            opacity="0.55"
          />
        </g>
        <circle cx="60" cy="43" r="4" fill="currentColor" opacity="0.85" />
      </svg>
    </div>

    <h3 className="rb-unavailable__title">{title}</h3>
    {body ? <p className="rb-unavailable__body">{body}</p> : null}

    <div className="rb-unavailable__actions">
      {onRetry ? (
        <button
          type="button"
          className="rb-btn rb-btn--primary"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? (
            <>
              <span className="rb-spin" aria-hidden="true" /> Trying again
            </>
          ) : (
            <>
              <i className="fa fa-rotate-right" aria-hidden="true" /> Try again
            </>
          )}
        </button>
      ) : null}
      {secondaryLabel && onSecondary ? (
        <button type="button" className="rb-btn rb-btn--secondary" onClick={onSecondary}>
          {secondaryLabel}
        </button>
      ) : null}
    </div>

    {note ? <p className="rb-unavailable__note">{note}</p> : null}
  </div>
);

export default UnavailablePanel;
